export const WORKFLOW_ENGLISH = {
  "datox.templates.title": "Templates",
  "datox.templates.description": "Start with a proven process. Make it your own.",
  "datox.templates.banking": "Banking operations",
  "datox.templates.onboarding": "Corporate Customer Onboarding",
  "datox.templates.onboarding.description": "Turn customer documents into an evidence-linked KYC case, resolve gaps, and prepare a reviewable decision.",
  "datox.templates.use": "Use my documents",
  "datox.templates.sample": "Try with sample data",
  "datox.templates.preview": "Workflow steps",
  "datox.templates.outputs": "Draft review report · Final decision report · Evidence & activity history",
  "datox.templates.integration": "Document-based review. External checks and system updates require your own evidence and follow-up.",
  "datox.templates.configure": "Configure your onboarding case",
  "datox.templates.unavailable": "This template is not available in the current workspace.",
  "datox.templates.name": "Case name",
  "datox.templates.name.placeholder": "Customer or company name",
  "datox.templates.project": "Project",
  "datox.templates.newProject": "Create a project for this case",
  "datox.templates.documents": "Required documents",
  "datox.templates.reviewers": "Reviewer emails",
  "datox.templates.reviewers.hint": "Separate emails with commas. Reviewers must have access to the project and sign in to record a decision.",
  "datox.templates.policy": "Review policy",
  "datox.templates.policy.default": "Verify entity identity, ownership, tax residency and screening evidence.",
  "datox.templates.branding": "Report heading",
  "datox.templates.additionalFields": "Additional customer fields",
  "datox.templates.additionalFields.hint": "Optional. Enter up to 10 field labels, separated by commas. These fields will be required in the customer profile.",
  "datox.templates.create": "Create onboarding case",
  "datox.templates.sample.name": "Northstar Trading — Sample onboarding",
  "datox.templates.sample.hint": "Synthetic documents and fixed sample analysis. A tax declaration is missing; add it, then select Run onboarding review to try the complete flow.",
  "datox.workflows.title": "Workflows",
  "datox.workflows.workspace.subtitle": "Customer onboarding · documents, due diligence and reviewer decisions",
  "datox.workflows.workspace.views": "Case workspace views",
  "datox.workflows.workspace.review": "Your onboarding review",
  "datox.workflows.workspace.missingHint": "Attach the missing required documents below to enable the review.",
  "datox.workflows.workspace.readyHint": "Run the review to prepare the profile, checks and decision package from the current documents.",
  "datox.workflows.workspace.stepCount": "Step {{count}} of {{total}}",
  "datox.workflows.workspace.assistantHint": "Ask about this case and its evidence",
  "datox.workflows.workspace.coverage": "Required document checklist",
  "datox.workflows.workspace.documentCount": "{{count}} of {{total}} required documents attached",
  "datox.workflows.workspace.uploadHint": "Drop each file onto its document card or choose an uploaded file. Supported formats: PDF, DOCX, XLSX, CSV, TXT and JSON.",
  "datox.workflows.workspace.processingHint": "Document changes are paused while the review runs. You can browse the steps to see saved results.",
  "datox.workflows.workspace.optional": "Supporting document",
  "datox.workflows.workspace.dropHint": "Drop a file here, or upload below.",
  "datox.workflows.workspace.uploadFor": "Upload {{document}}",
  "datox.workflows.workspace.reviewers": "Reviewer decisions",
  "datox.workflows.view.case": "Onboarding case",
  "datox.workflows.view.workflow": "Workflow data & reports",
  "datox.workflows.view.dashboard": "Dashboards",
  "datox.workflows.dailyPeriod": "Open project period · {{date}}",
  "datox.workflows.description": "Resume your cases, review evidence, and track decisions.",
  "datox.workflows.new": "Start from a template",
  "datox.workflows.reporting": "Reporting workflows",
  "datox.workflows.templateWorkflow": "Template workflow",
  "datox.workflows.empty": "No onboarding cases yet. Choose a template to create your first case.",
  "datox.workflows.search": "Search cases",
  "datox.workflows.all": "All statuses",
  "datox.workflows.progress": "{{completed}} of {{total}} steps complete",
  "datox.workflows.version": "Template v{{version}} · Revision {{revision}}",
  "datox.workflows.resume": "Open case",
  "datox.workflows.back": "Back to reporting workflow",
  "datox.workflows.sample": "Sample case",
  "datox.workflows.sample.banner": "Synthetic demonstration. No live screening or banking-system updates are performed.",
  "datox.workflows.readonly": "You have read-only access to this case. Assigned reviewers can record a decision at the review step.",
  "datox.workflows.error": "Could not load the workflow. Please try again.",
  "datox.workflows.error.request": "The action could not finish. Please try again.",
  "datox.workflows.error.conflict": "The case changed or another analysis is running. Reload the case before trying again.",
  "datox.workflows.error.access": "You do not have permission to perform this action.",
  "datox.workflows.error.validation": "Check required fields, documents, analysis findings, review notes, and preceding steps before continuing.",
  "datox.workflows.retry": "Reload",
  "datox.workflows.cardActions": "Actions for {{name}}",
  "datox.workflows.deleteTitle": "Delete workflow",
  "datox.workflows.deleteConfirm": "Delete {{name}}?",
  "datox.workflows.deleteDescription": "The onboarding case will be removed from your workflows. The project period and its other data remain available.",
  "datox.workflows.deleteError": "Could not delete this workflow. Reload and try again.",
  "datox.workflows.save": "Save changes",
  "datox.workflows.discard": "Discard changes & reload",
  "datox.workflows.saved": "Saved",
  "datox.workflows.unsaved": "Unsaved changes",
  "datox.workflows.saveFirst": "Save your changes before switching steps or reloading.",
  "datox.workflows.working": "Working…",
  "datox.workflows.analyze": "Analyze this step",
  "datox.workflows.extractProfile": "Extract company profile",
  "datox.workflows.continueProfile": "Continue to company profile",
  "datox.workflows.complete": "Complete step",
  "datox.workflows.stale": "Earlier inputs changed. Review and rerun analysis before completing this step.",
  "datox.workflows.reviewNotes": "Review notes and resolved exceptions",
  "datox.workflows.confirm": "I reviewed the current evidence and recorded the outcome.",
  "datox.workflows.required": "Required",
  "datox.workflows.missing": "Missing",
  "datox.workflows.attached": "Attached",
  "datox.workflows.chooseFile": "Choose an uploaded file",
  "datox.workflows.upload": "Upload document",
  "datox.workflows.openFile": "Download source",
  "datox.workflows.remove": "Remove attachment",
  "datox.workflows.sample.resolve": "Add sample tax declaration",
  "datox.workflows.findings": "Findings",
  "datox.workflows.facts": "Source-backed facts",
  "datox.workflows.applyFact": "Use this value",
  "datox.workflows.requests": "Missing-information requests",
  "datox.workflows.proposals": "Proposed follow-up actions",
  "datox.workflows.noAnalysis": "Run analysis to extract facts, identify gaps, and prepare next actions.",
  "datox.workflows.assistant": "Case assistant",
  "datox.workflows.chat.open": "Open chat",
  "datox.workflows.chat.opening": "Opening chat…",
  "datox.workflows.chat.openHint": "Open the regular agent chat with this case’s documents, profile, and analysis available as context.",
  "datox.workflows.chat.openError": "Could not open the agent chat. Please try again.",
  "datox.workflows.chat.regularAgent": "Datox agent",
  "datox.workflows.chat.back": "Back to onboarding case",
  "datox.workflows.chat.hint": "A persistent conversation linked to this case and available in Chats. Each message uses the latest case data. Suggested changes are not applied automatically.",
  "datox.workflows.chat.history": "Case conversation",
  "datox.workflows.chat.empty": "Ask a question to start a conversation about this case.",
  "datox.workflows.chat.you": "You",
  "datox.workflows.chat.thinking": "The case assistant is preparing a response…",
  "datox.workflows.chat.failed": "The assistant could not finish this response. You can send the question again; the conversation is saved.",
  "datox.workflows.chat.olderRevision": "Based on case revision {{revision}}. The case has changed since this answer.",
  "datox.workflows.processing.active": "The agent is processing your onboarding case",
  "datox.workflows.processing.starting": "Starting the onboarding review…",
  "datox.workflows.processing.previousReview": "Updating this review. The previous results remain visible for reference until the new analysis is ready.",
  "datox.workflows.refresh.delayed": "Updates are temporarily delayed. Showing your last loaded results.",
  "datox.workflows.report.view": "View report",
  "datox.workflows.report.approval": "View report & send for approval",
  "datox.workflows.report.download": "Download report",
  "datox.workflows.processing.hint": "Upload the required documents, then select Run onboarding review to prepare the profile, checks, gaps, and review package.",
  "datox.workflows.processing.failed": "Processing paused after an error. Your completed steps are saved.",
  "datox.workflows.processing.progress": "{{count}} of {{total}} processing stages saved. You can leave this page and return later.",
  "datox.workflows.processing.run": "Run onboarding review",
  "datox.workflows.recommendation.ready_for_review": "Ready for reviewer decision",
  "datox.workflows.recommendation.needs_information": "Additional information required",
  "datox.workflows.recommendation.escalate": "Escalation recommended",
  "datox.workflows.screeningSource.sample": "Synthetic screening evidence — no live check",
  "datox.workflows.screeningSource.uploaded_evidence": "Uploaded screening evidence reviewed — no external check run",
  "datox.workflows.screeningSource.not_performed": "Screening not performed",
  "datox.workflows.assessments": "Agent assessments and rationale",
  "datox.workflows.review.requestChanges": "Request information",
  "datox.workflows.review.rejectCase": "Reject case",
  "datox.workflows.assistant.hint": "Ask about this step and the attached evidence. Answers are saved with the case.",
  "datox.workflows.question": "Your question",
  "datox.workflows.ask": "Ask assistant",
  "datox.workflows.attempts": "Analysis history",
  "datox.workflows.analysisFailed": "Analysis was interrupted or unavailable. Retry the action; no step was completed.",
  "datox.workflows.activity": "Activity history",
  "datox.workflows.review.hint": "Review the case summary and draft report. Use the report view to email it for approval; the assigned case reviewer records the final case decision here.",
  "datox.workflows.review.comments": "Decision comments",
  "datox.workflows.review.approve": "Approve case",
  "datox.workflows.review.reject": "Request changes",
  "datox.workflows.review.waiting": "Awaiting decision",
  "datox.workflows.review.closed": "Review closed. Edit an earlier step to reopen the case and request fresh decisions.",
  "datox.workflows.review.complete": "Review complete. The final decision report is ready to view or download above.",
  "datox.workflows.review.finishExisting": "Generate final report for this approved case",
  "datox.workflows.pack": "Generate decision pack & complete",
  "datox.workflows.download": "Download decision pack",
  "datox.workflows.completion.hint": "After all reviewers approve, generate the final decision report with the reviewed evidence and decisions. Account creation and external system updates remain follow-up actions.",
  "datox.workflows.step.profile": "Company profile",
  "datox.workflows.step.documents": "Documents",
  "datox.workflows.step.kyc": "KYC & ownership",
  "datox.workflows.step.screening": "Screening & risk",
  "datox.workflows.step.gaps": "Resolve gaps",
  "datox.workflows.step.review": "Review & decision",
  "datox.workflows.step.completion": "Final decision report",
  "datox.workflows.hint.profile": "Review the company information extracted by the onboarding review, then confirm requested products and the case owner.",
  "datox.workflows.hint.documents": "Upload and attach the required company documents. When the checklist is complete, select Run onboarding review to prepare the case.",
  "datox.workflows.hint.kyc": "Review directors, beneficial ownership, and source-backed facts. Run analysis after changing customer details.",
  "datox.workflows.hint.screening": "Record the screening provider evidence, date, outcome and risk assessment. The assistant analyzes supplied evidence; it does not perform a live screening check.",
  "datox.workflows.hint.gaps": "Check gaps you have reviewed. Add missing evidence in Documents and run onboarding review again to reassess the case.",
  "datox.workflows.hint.review": "Make a recorded decision using the current case evidence.",
  "datox.workflows.hint.completion": "Generate the final decision report after reviewer approval and finish the onboarding review. Banking-system updates remain separate follow-up actions.",
  "datox.workflows.field.legal_name": "Legal entity name",
  "datox.workflows.field.registration_number": "Registration number",
  "datox.workflows.field.jurisdiction": "Jurisdiction",
  "datox.workflows.field.registered_address": "Registered address",
  "datox.workflows.field.products": "Requested banking products / services",
  "datox.workflows.field.business_activities": "Business activities",
  "datox.workflows.field.tax_identification_number": "Tax identification number",
  "datox.workflows.field.tax_residency": "Tax residency",
  "datox.workflows.document.identity": "Identity documents",
  "datox.workflows.document.application": "Account application / supporting forms",
  "datox.workflows.analyzed": "{{count}} of 5 analysis stages processed",
  "datox.workflows.replaceDocument": "Replace document",
  "datox.workflows.existingFile": "Choose from uploaded files",
  "datox.workflows.addSupportingDocument": "Add supporting evidence",
  "datox.workflows.chooseDocumentType": "Choose document type",
  "datox.workflows.ownership.useExtracted": "Use extracted ownership records",
  "datox.workflows.ownership.manualNotice": "Saved manual ownership values may differ from these extracted records. Use the extracted records to replace the saved manual values and recheck ownership.",
  "datox.workflows.party.name": "Party",
  "datox.workflows.party.roles": "Roles",
  "datox.workflows.party.direct": "Direct interest",
  "datox.workflows.party.indirect": "Indirect interest",
  "datox.workflows.party.via": "Through",
  "datox.workflows.party.source": "Source",
  "datox.workflows.party.director": "Director",
  "datox.workflows.party.manager": "Manager",
  "datox.workflows.party.signatory": "Signatory",
  "datox.workflows.party.shareholder": "Shareholder",
  "datox.workflows.party.declaredOwner": "Declared beneficial owner",
  "datox.workflows.actions.title": "Required actions",
  "datox.workflows.actions.owner": "Action owner",
  "datox.workflows.actions.due": "Due date",
  "datox.workflows.actions.status": "Action status",
  "datox.workflows.actions.open": "Open",
  "datox.workflows.actions.inProgress": "In progress",
  "datox.workflows.actions.ready": "Reviewed",
  "datox.workflows.actions.closed": "Closed",
  "datox.workflows.actions.unassigned": "Unassigned",
  "datox.workflows.actions.noDeadline": "No due date",
  "datox.workflows.actions.none": "No outstanding actions recorded.",
  "datox.workflows.actions.manage": "View gaps",
  "datox.workflows.actions.reviewHint": "Checkmarks record that you reviewed a gap; they do not verify missing evidence or approve the case.",
  "datox.workflows.actions.resolved": "Resolved after updated evidence was reviewed",
  "datox.workflows.field.case_owner": "Case owner",
  "datox.workflows.field.directors": "Directors",
  "datox.workflows.field.beneficial_owners": "Beneficial owners",
  "datox.workflows.field.ownership_percentages": "Ownership percentages",
  "datox.workflows.field.screening_outcome": "Screening outcome and provider",
  "datox.workflows.field.screening_date": "Screening date",
  "datox.workflows.field.risk_rating": "Risk rating and rationale",
  "datox.workflows.document.registration": "Company registration",
  "datox.workflows.document.ownership": "Ownership declaration",
  "datox.workflows.document.tax": "Tax declaration",
  "datox.workflows.document.screening": "Screening evidence",
  "datox.workflows.document.signatories": "Signatory authority",
  "datox.workflows.document.address": "Proof of address",
  "datox.workflows.status.pending": "Not started",
  "datox.workflows.status.stale": "Needs recheck",
  "datox.workflows.status.completed": "Completed",
  "datox.workflows.status.blocked": "Needs information",
  "datox.workflows.status.needs_review": "Ready for review",
  "datox.workflows.status.in_progress": "In progress",
  "datox.workflows.status.approved": "Approved",
  "datox.workflows.status.rejected": "Changes requested",
  "datox.workflows.status.running": "Analyzing",
  "datox.workflows.status.failed": "Failed",
  "datox.workflows.status.superseded": "Superseded by changes",
  "datox.workflows.status.queued": "Queued",
  "datox.workflows.status.processing": "Processing",
  "datox.workflows.status.processing_failed": "Processing paused",
  "datox.workflows.status.ready_for_review": "Ready for decision",
  "datox.workflows.status.needs_information": "Needs information",
  "datox.workflows.status.changes_requested": "Information requested",
  "datox.workflows.severity.info": "Information",
  "datox.workflows.severity.warning": "Review needed",
  "datox.workflows.severity.blocking": "Action required",
  "datox.workflows.event.created": "Case created",
  "datox.workflows.event.step.edited": "Step updated",
  "datox.workflows.event.step.completed": "Step completed",
  "datox.workflows.event.sample.resolved": "Sample document received",
  "datox.workflows.event.decision": "Reviewer decision recorded",
  "datox.workflows.event.analysis.started": "Analysis started",
  "datox.workflows.event.analysis.failed": "Analysis failed",
  "datox.workflows.event.analysis.finished": "Analysis finished",
  "datox.workflows.event.processing.queued": "Onboarding processing queued",
  "datox.workflows.event.processing.step": "Processing stage saved",
  "datox.workflows.event.processing.finished": "Review package prepared",
  "datox.workflows.event.chat.message": "Case assistant question submitted",
  "datox.workflows.event.chat.answered": "Case assistant response saved",
} as const
